const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '收录超过10万部免费电影和免费电视剧全集，涵盖动作、喜剧、爱情、科幻、悬疑、动漫、综艺、纪录片等全类型，满足各类观影需求。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P至4K超高清播放，智能适配您的网络带宽与设备屏幕，确保每一帧都清晰锐利，带来影院级的视觉效果。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放',
    desc: '采用先进CDN加速和多节点分流技术，播放不卡顿不缓冲。智能切换最优线路，即使网络波动也能保持稳定的观影体验。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '永久免费',
    desc: '无需注册、无需付费、无需会员，所有影视资源永久免费在线观看。无广告干扰，纯净观影体验，让每一位影迷都能自由追剧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              平台优势
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              选择爱看影院的四大理由，让追剧观影更简单
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feat, idx) => (
              <div
                key={feat.title}
                className="bg-background-800/40 border border-background-700/30 rounded-xl p-6 text-center group hover:border-primary-500/25 hover:bg-background-800/70 transition-all duration-300"
              >
                <div className={`w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl ${
                  idx === 0
                    ? 'bg-primary-500/10 text-primary-400'
                    : idx === 1
                    ? 'bg-accent-500/10 text-accent-400'
                    : idx === 2
                    ? 'bg-secondary-500/10 text-secondary-400'
                    : 'bg-primary-500/10 text-primary-400'
                } group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-100 font-bold mb-2">{feat.title}</h3>
                <p className="text-xs text-foreground-400 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}